import { Crescent } from "./Reveal";
import { useLang } from "@/i18n";

function Row({ items }) {
    return (
        <div className="flex shrink-0 items-center">
            {items.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="whitespace-nowrap px-8 font-display text-2xl font-medium italic text-[#FAFAFA] md:px-12 md:text-4xl">
                        {item}
                    </span>
                    <Crescent className="h-5 w-5 shrink-0 text-brand-lime md:h-6 md:w-6" />
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    const { t } = useLang();
    return (
        <div
            data-testid="services-marquee"
            className="marquee-band relative -rotate-1 overflow-hidden border-y border-brand-olive/40 bg-brand-navy py-5 md:py-6"
        >
            <div className="animate-marquee flex w-max">
                <Row items={t.marquee} />
                <Row items={t.marquee} ariaHidden />
            </div>
        </div>
    );
}
